/**
 * Computes the remaining quota (e.g. processing seconds, library video seconds)
 * by subtracting used from limit, clamped to a minimum of 0.
 *
 * Used by UploadModal to gate form submission when the user has insufficient
 * remaining processing time or library quota.
 *
 * @param limit - The plan's maximum quota (e.g. `planProcessingSeconds`).
 * @param used  - The amount consumed so far (e.g. `currentMonthProcessingSeconds`).
 * @returns     The remaining quota, never negative.
 */
export function computeRemainingQuota(limit: number, used: number): number {
  return Math.max(0, limit - used);
}
